import { all, put, takeEvery } from "redux-saga/effects";
import URLs from "../../../constants/urls";
import { apiPython as api } from "../../../service/api";
import { GET_ALL_EMPLOYEES, GET_ALL_EMPLOYEES_FAILURE, GET_ALL_EMPLOYEES_SUCCESS, GET_EMPLOYEES } from "../../actions/Employees/GetAllEmployeesType";
import { getAllEmployees } from "../../features/Employees/GetAllEmployeesSlice";

export function* getAllEmployeesList() {
    try {
        const response = yield api.get(`${URLs.GET_ALL_EMPLOYEES}`);
        yield put(getAllEmployees(response.data));
    } catch (error) {
        console.log('Error - Employees:', error);
        const errorMessage = error?.response?.data?.message || 'Could not fetch employees';
        yield put({ type: GET_ALL_EMPLOYEES_FAILURE, payload: error.message });
    }
}

export function* watchAllEmployees() {
    yield takeEvery(GET_ALL_EMPLOYEES, getAllEmployeesList);
}

export default function* getAllEmployeesSaga() {
    yield all([watchAllEmployees()]);
}
